/**
 * Enum for calendar legend items' types.
 * @since 1.23.0
 * @public
 */
enum CalendarLegendItemType {
	/**
	 * Represents the "Today" item in the calendar legend.
	 * @private
	 */
	Today = "Today",
	/**
	 * Represents the "Selected" item in the calendar legend.
	 * @private
	 */
	Selected = "Selected",
	/**
	 * Set when no type is set.
	 * @public
	 */
	None = "None",
	/**
	 * Represents the "Working" item in the calendar legend.
	 * @public
	 */
	Working = "Working",
	/**
	 * Represents the "NonWorking" item in the calendar legend.
	 * @public
	 */
	NonWorking = "NonWorking",
	/**
	 * Represents the "Type01" item in the calendar legend.
	 * @public
	 */
	Type01 = "Type01",
	/**
	 * Represents the "Type02" item in the calendar legend.
	 * @public
	 */
	Type02 = "Type02",
	/**
	 * Represents the "Type03" item in the calendar legend.
	 * @public
	 */
	Type03 = "Type03",
	/**
	 * Represents the "Type04" item in the calendar legend.
	 * @public
	 */
	Type04 = "Type04",
	/**
	 * Represents the "Type05" item in the calendar legend.
	 * @public
	 */
	Type05 = "Type05",
	/**
	 * Represents the "Type06" item in the calendar legend.
	 * @public
	 */
	Type06 = "Type06",
	/**
	 * Represents the "Type07" item in the calendar legend.
	 * @public
	 */
	Type07 = "Type07",
	/**
	 * Represents the "Type08" item in the calendar legend.
	 * @public
	 */
	Type08 = "Type08",
	/**
	 * Represents the "Type09" item in the calendar legend.
	 * @public
	 */
	Type09 = "Type09",
	/**
	 * Represents the "Type10" item in the calendar legend.
	 * @public
	 */
	Type10 = "Type10",
	/**
	 * Represents the "Type11" item in the calendar legend.
	 * @public
	 */
	Type11 = "Type11",
	/**
	 * Represents the "Type12" item in the calendar legend.
	 * @public
	 */
	Type12 = "Type12",
	/**
	 * Represents the "Type13" item in the calendar legend.
	 * @public
	 */
	Type13 = "Type13",
	/**
	 * Represents the "Type14" item in the calendar legend.
	 * @public
	 */
	Type14 = "Type14",
	/**
	 * Represents the "Type15" item in the calendar legend.
	 * @public
	 */
	Type15 = "Type15",
	/**
	 * Represents the "Type16" item in the calendar legend.
	 * @public
	 */
	Type16 = "Type16",
	/**
	 * Represents the "Type17" item in the calendar legend.
	 * @public
	 */
	Type17 = "Type17",
	/**
	 * Represents the "Type18" item in the calendar legend.
	 * @public
	 */
	Type18 = "Type18",
	/**
	 * Represents the "Type19" item in the calendar legend.
	 * @public
	 */
	Type19 = "Type19",
	/**
	 * Represents the "Type20" item in the calendar legend.
	 * @public
	 */
	Type20 = "Type20",
}

export default CalendarLegendItemType;
